@if (order) {
<mat-toolbar class="bg-transparent px-0 w-full items-center gap-2 min-w-0 flex" (click)="goTo()" [ngClass]="{
      'selectable-toolbar hover:cursor-pointer': selectable,
      'justify-end': tableMode,
      'justify-between': !tableMode,
      'premium-page-header-card': !tableMode
    }">
  <!-- Order information container -->
  @if (!tableMode) {
  <div class="flex flex-row items-center flex-1 min-w-0 order-text-group">
    @if (authService.isLoggedIn && withBackButton) {
    <button mat-icon-button (click)="location.back()" class="mr-2 btn-back">
      <mat-icon>arrow_back</mat-icon>
    </button>
    }
    <app-state-indicator [order]="order"></app-state-indicator>
    <div class="flex flex-col min-w-0 max-w-full pl-2">
      <h2 class="m-0 text-lg text-ellipsis overflow-hidden whitespace-nowrap max-w-96">{{ order.transactionId }}</h2>
      @if (!tableMode) {
      <span class="text-sm text-gray-500 overflow-hidden text-ellipsis whitespace-nowrap max-w-96">
        {{ order.reference }} {{ order.name }} - {{ 'version'|translate }} #{{ order.batVersion + 1 }}
      </span>
      }
    </div>
  </div>
  }
  <!-- Files processing container -->
  <mat-menu #filesErrorsMenu="matMenu" panelClass="files-errors-menu">
    <div class="files-errors-panel" (click)="$event.stopPropagation()">
      <app-files-errors [order]="order" [panelMode]="true"></app-files-errors>
    </div>
  </mat-menu>
  @if (fileTask || importTask || nestingTask || hasErrors()) {
  <div class="hidden lg:flex flex-col shrink-0">
    <div class="flex flex-row place-content-end gap-2" (click)="$event.stopPropagation()">
      @if (!fileTask && !importTask && hasManualProofs() &&
      order.state === OrderState.PROCESSING && authService.hasRole(RolesEnum.ORDER_WRITE)) {
      <button mat-icon-button class="btn-download" [matTooltip]="'manualProofUpload' | translate"
        [routerLink]="['/', organizationService.currentOrganization.oid, 'bat', order.id]">
        <mat-icon>upload_file</mat-icon>
      </button>
      }
      <!-- Files errors button -->
      @if (!fileTask && !importTask && !nestingTask?.inProgress && authService.hasRole(RolesEnum.ORDER_WRITE) &&
      ((hasErrors() && order.state === OrderState.PROCESSING) || nestingTask?.withError)) {
      <div class="flex flex-row place-content-start items-center">
        <button mat-icon-button class="btn-error pulsing-error"
          [matMenuTriggerFor]="hasErrors() ? filesErrorsMenu : null" [matTooltip]="errorTooltip">
          <mat-icon>error</mat-icon>
        </button>
      </div>
      }
      <!-- Files processing progress indicator -->
      @if (fileTask) {
      <div class="text-sm font-light">
        {{ fileTask.date | date:'short' : '' : translate.currentLang }}
      </div>
      }
      @if (importTask) {
      <div class="text-sm font-light">
        {{ importTask.date | date:'short' : '' : translate.currentLang }}
      </div>
      }
      @if (nestingTask?.inProgress) {
      <div class="text-sm font-light">
        {{ nestingTask.date | date:'short' : '' : translate.currentLang }}
      </div>
      }
    </div>
    @if (fileTask || importTask || nestingTask?.inProgress) {
    <mat-progress-bar color="primary" mode="indeterminate" class="modern-progress-bar">
    </mat-progress-bar>
    }
  </div>
  }

  <div class="flex flex-row shrink-0 gap-2" (click)="$event.stopPropagation()">
    @if (!isProcessingInProgress()) {
    <!-- Shortcut actions -->
    <div class="action-shortcuts w-fit flex-row place-content-end gap-2">
      @if (authService.hasRole([RolesEnum.ORDER_WRITE, RolesEnum.WORKSHOP_WRITE, RolesEnum.SALES])) {
      <button mat-icon-button (click)="sync(order)" class="btn-sync" [class.spinning]="isRotating">
        <mat-icon [class.animate-sync-spin]="isRotating">sync</mat-icon>
      </button>
      }
      @if (order.source === SourceType.MULTIPRESS && !tableMode &&
      authService.hasRole([RolesEnum.ORDER_WRITE, RolesEnum.WORKSHOP_WRITE, RolesEnum.SALES])) {
      <button mat-icon-button (click)="downloadProductionFile()" class="btn-download-production">
        @if (!productionFileProgress) {
        <mat-icon>find_in_page</mat-icon>
        }
        @if (productionFileProgress) {
        <mat-spinner diameter="22" color="accent" mode="indeterminate"></mat-spinner>
        }
      </button>
      }
      <!-- Comment and locking container -->
      @if (authService.hasRole([RolesEnum.ORDER_WRITE, RolesEnum.SALES])) {
      <app-lock-by-editor [object]="order">
      </app-lock-by-editor>
      }
      @if (!tableMode) {
      <button mat-icon-button (click)="download()" [matTooltip]="'downloadOrderFiles.title'|translate"
        class="btn-download" [disabled]="order.state < OrderState.PROCESSING">
        @if (!zipProgress) {
        <mat-icon>download</mat-icon>
        }
        @if (zipProgress) {
        <mat-spinner diameter="22" color="accent" mode="indeterminate"></mat-spinner>
        }
      </button>
      }
      <button mat-icon-button (click)="openOrderInformationDialog()" [matTooltip]="'common.info.button'|translate" class="btn-info">
        <mat-icon>info</mat-icon>
      </button>
    </div>
    }
    @if (authService.isLoggedIn) {
    <button mat-icon-button [matMenuTriggerFor]="orderNavigationMenu" class="btn-more"
      [class.btn-more--processing]="isProcessingInProgress()">
      <mat-icon class="btn-more-icon">more_vert</mat-icon>
      @if (isProcessingInProgress()) {
      <mat-icon class="btn-more-processing-icon animate-sync-spin lg:hidden" aria-hidden="true">sync</mat-icon>
      }
    </button>
    }
    <mat-menu #orderNavigationMenu="matMenu">
      @if (authService.isLoggedIn) {
      <div class="px-4 w-fit max-w-xs">
        <div class="lg:hidden flex flex-col" (click)="$event.stopPropagation()">
          @if (fileTask) {
            <button mat-menu-item disabled>
              <mat-icon>hourglass_empty</mat-icon>
              <span>{{ fileTask.date | date:'short' : '' : translate.currentLang }}</span>
            </button>
          }
          @if (importTask) {
            <button mat-menu-item disabled>
              <mat-icon>hourglass_empty</mat-icon>
              <span>{{ importTask.date | date:'short' : '' : translate.currentLang }}</span>
            </button>
          }
          @if (fileTask || importTask || nestingTask?.inProgress) {
            <div class="px-4 py-2">
              <mat-progress-bar color="primary" class="modern-progress-bar" mode="indeterminate">
              </mat-progress-bar>
            </div>
          }
          @if (authService.hasRole([RolesEnum.ORDER_WRITE, RolesEnum.WORKSHOP_WRITE, RolesEnum.SALES])) {
            <button mat-menu-item (click)="sync(order)">
              <mat-icon [class.animate-sync-spin]="isRotating">sync</mat-icon>
              <span>{{ 'synchronize' | translate }}</span>
            </button>
          }
          @if (order.source === SourceType.MULTIPRESS && !tableMode &&
          authService.hasRole([RolesEnum.ORDER_WRITE, RolesEnum.WORKSHOP_WRITE, RolesEnum.SALES])) {
            <button mat-menu-item (click)="downloadProductionFile()">
              @if (!productionFileProgress) {
                <mat-icon>find_in_page</mat-icon>
              }
              @if (productionFileProgress) {
                <mat-spinner diameter="22" color="accent" mode="indeterminate" class="mr-2"></mat-spinner>
              }
              <span>{{ 'order.confirmClose.print' | translate }}</span>
            </button>
          }
          @if (authService.hasRole([RolesEnum.ORDER_WRITE, RolesEnum.SALES])) {
            <app-lock-by-editor [object]="order" [isMenuItem]="true" class="w-full">
            </app-lock-by-editor>
          }
          @if (!tableMode) {
            <button mat-menu-item (click)="download()" [disabled]="order.state < OrderState.PROCESSING">
              @if (!zipProgress) {
                <mat-icon>download</mat-icon>
              }
              @if (zipProgress) {
                <mat-spinner diameter="22" color="accent" mode="indeterminate" class="mr-2"></mat-spinner>
              }
              <span>{{ 'downloadOrderFiles.title' | translate }}</span>
            </button>
          }
          <button mat-menu-item (click)="openOrderInformationDialog()">
            <mat-icon>info</mat-icon>
            <span>{{ 'common.info.button' | translate }}</span>
          </button>
          @if (hasErrors() && !fileTask && !importTask && hasManualProofs() &&
          order.state === OrderState.PROCESSING && authService.hasRole(RolesEnum.ORDER_WRITE)) {
            <button mat-menu-item [routerLink]="['/', organizationService.currentOrganization.oid, 'bat', order.id]">
              <mat-icon>upload_file</mat-icon>
              <span>{{ 'manualProofUpload' | translate }}</span>
            </button>
          }
          @if (!fileTask && !importTask && !nestingTask?.inProgress && authService.hasRole(RolesEnum.ORDER_WRITE) &&
          ((hasErrors() && order.state === OrderState.PROCESSING) || nestingTask?.withError)) {
            <button mat-menu-item [matMenuTriggerFor]="hasErrors() ? filesErrorsMenu : null">
              <mat-icon style="color: var(--okto-error, var(--mat-sys-error, #f44336))">error</mat-icon>
              <span>{{ errorTooltip }}</span>
            </button>
          }
          <mat-divider class="my-2"></mat-divider>
        </div>
        <button mat-menu-item [routerLink]="['/', organizationService.currentOrganization.oid, 'order', order.id]"
          queryParamsHandling="preserve">
          <mat-icon>shopping_basket</mat-icon>
          {{ 'TEMPLATES.INSTRUCTIONS' | translate }}
        </button>
        <button mat-menu-item [routerLink]="['/', organizationService.currentOrganization.oid, 'templates', order.id]"
          queryParamsHandling="preserve">
          <mat-icon>picture_as_pdf</mat-icon>
          {{ 'ADMIN.SHOW_FILES_VIEW' | translate }}
        </button>
        <button mat-menu-item [routerLink]="['/', organizationService.currentOrganization.oid, 'bat', order.id]"
          queryParamsHandling="preserve">
          <mat-icon>library_add_check</mat-icon>
          {{ 'ADMIN.SHOW_BAT_VIEW' | translate }}
        </button>
        <button mat-menu-item [routerLink]="['/', organizationService.currentOrganization.oid, 'transport', order.id]"
          queryParamsHandling="preserve">
          <mat-icon>local_shipping</mat-icon>
          {{ 'transport' | translate }}
        </button>
        @if (authService.hasRole([RolesEnum.ORDER_WRITE, RolesEnum.WORKSHOP_WRITE, RolesEnum.SALES])) {
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="openCustomerFolder(order)">
          <mat-icon>folder</mat-icon>
          {{ 'ADMIN.OPEN_FOLDER' | translate }}
        </button>
        @if (authService.hasRole([RolesEnum.ORDER_WRITE, RolesEnum.SALES])) {
        <!-- Emailing container -->
        @if (order.state === OrderState.WAIT_FILES || order.state === OrderState.PROCESSING) {
        <button mat-menu-item (click)="sendFileEmail(order, 0)" [disabled]="!order.emailIsActive">
          <mat-icon>contact_mail</mat-icon>
          {{ 'sendEmail' | translate }}
        </button>
        }
        @if (order.state !== OrderState.WAIT_FILES && order.state !== OrderState.PROCESSING) {
        <button mat-menu-item (click)="sendFileEmail(order, 1)"
          [disabled]="!order.emailIsActive || order.state !== OrderState.WAIT_BAT">
          <mat-icon>contact_mail</mat-icon>
          {{ 'sendEmail' | translate }}
        </button>
        }
        @if (order.state === OrderState.PROCESSING ||
        order.state === OrderState.WAIT_BAT ||
        order.state === OrderState.BAT_ACCEPTED ||
        order.state === OrderState.BAT_REFUSED ||
        order.state === OrderState.PRODUCTION ||
        order.state === OrderState.FINISHED) {
        <button mat-menu-item (click)="openUnlockOrderDialog(order)">
          <mat-icon>restore_page</mat-icon>
          {{ 'restore' | translate }}
        </button>
        }
        @if (order.state === OrderState.PROCESSING && authService.hasRole(RolesEnum.ADVANCED)) {
        <button mat-menu-item (click)="forceWaitingValidation()">
          <mat-icon>rule_folder</mat-icon>
          {{ 'bat.force.button' | translate }}
        </button>
        }
        }
        <button mat-menu-item (click)="print()">
          <mat-icon>print</mat-icon>
          {{ 'print' | translate }}
        </button>
        @if (authService.hasRole([RolesEnum.ORDER_WRITE, RolesEnum.SALES])) {
        @if (order.state === OrderState.WAIT_FILES || order.state === OrderState.PROCESSING) {
        <button mat-menu-item (click)="getLink(1, $event)" [disabled]="progress">
          <div class="flex flex-row items-center gap-2">
            @if (!progress) {
            <mat-icon>link</mat-icon>
            }
            @if (progress) {
            <mat-spinner mode="indeterminate" diameter="22" color="accent"></mat-spinner>
            }
            {{ 'ADMIN.COPY_DOWN_LINK' | translate }}
          </div>
        </button>
        }
        @if (order.state === OrderState.WAIT_BAT) {
        <button mat-menu-item (click)="getLink(0, $event)">
          <div class="flex flex-row items-center gap-2">
            @if (!progress) {
            <mat-icon>link</mat-icon>
            }
            @if (progress) {
            <mat-spinner mode="indeterminate" diameter="22" color="accent"></mat-spinner>
            }
            {{ 'ADMIN.COPY_BAT_LINK' | translate }}
          </div>
        </button>
        }
        @if (order.state !== OrderState.FINISHED) {
        <button mat-menu-item (click)="openDeleteOrderDialog(order)">
          <mat-icon>delete</mat-icon>
          {{ 'archive' | translate }}
        </button>
        }
        }
        }
      </div>
      }
    </mat-menu>
  </div>
</mat-toolbar>
}